module.exports = __webpack_public_path__ + "img/logo.05a01805.svg";